<template>
  <v-container :class="'main-container' + (showDesktopVersion ? '' : ' zero-padding')">
    <v-layout wrap>
      <page-header />
      <top-menu v-if="showDesktopVersion" />
      <left-menu v-if="!showDesktopVersion" />
      <right-menu v-if="!showDesktopVersion" />
      <template v-if="!showDesktopVersion">
        <v-container class="search-form-container" >
          <search-form />
        </v-container>
        <v-layout
          style="background:white;width: 100%;"
          :class="showDesktopVersion ? 'mt-3' : ''"
        >
          <div :style="(showDesktopVersion
            ? 'width:calc(100% - 240px);'
            : 'width:calc(100% - 10px);') + 'margin: 5px; padding:10px;'">
            <my-loader v-if="progressSearching" :spacing="50" />
            <objects-list v-else />
          </div>
        </v-layout>
      </template>
      <v-flex v-else xs12>
        <v-layout class="content-area" wrap>
          <div class="left-col">
            <search-form />
            <facebook-frame />
            <main-share />
            <banners />
            <contact-banner />
          </div>
          <div
            id="content-area"
            class="right-col" :style="showDesktopVersion
            ? 'width:calc(100% - 240px)'
            : ''">
            <my-loader v-if="progressSearching" :spacing="50" />
            <objects-list v-else />
          </div>
        </v-layout>
      </v-flex>
      <page-footer />
    </v-layout>
  </v-container>
</template>

<script>
import sharedComputed from './sharedComputed'
import sharedMethods from './../methods/sharedMethods'
import MyLoader from './../components/_MyLoader'
import FacebookFrame from './../components/_FacebookFrame'
import Banners from './../components/_Banners'
import ContactBanner from './../components/_ContactBanner'
import MainShare from './../components/_MainShare'
import ObjectsList from './../components/ObjectsList'
import PageHeader from './../components/_PageHeader'
import PageFooter from './../components/_PageFooter'
import SearchForm from './../components/SearchForm'
import TopMenu from './../components/TopMenu'
import LeftMenu from './../components/LeftMenu'
import RightMenu from './../components/RightMenu'
import CalendarNavigation from './../components/CalendarNavigation'
import { createHelpers } from 'vuex-map-fields'
import _filters from './../_filters'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'List',

  metaInfo () {
    return this.getMetaTags()
  },

  components: {
    PageHeader,
    PageFooter,
    SearchForm,
    TopMenu,
    ObjectsList,
    CalendarNavigation,
    FacebookFrame,
    MainShare,
    Banners,
    ContactBanner,
    LeftMenu,
    RightMenu,
    MyLoader
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    routeQuery () {
      return JSON.stringify(this.$route.query)
    }
  },

  mounted () {
    this.isHydrated = true
  },

  watch: {
    routeQuery () {
      this.$nextTick(() => {
        if (!this.progressSearching) {
          this.parseSearchFiltersFromQuery()
          this.searchObjects()
        }
      })
    }
  },

  created () {
    this.metaTitle = this.metaSiteName

    this.metaUrl = this.defaultMetaUrl
    this.metaDescription = this.defaultMetaDescription
    this.metaImage = this.defaultMetaImage

    this.setContentAreaWidth()
    this.parseSearchFiltersFromQuery()
    if (this.filtersHash && this.filtersHash === _filters.getHash(this.$store.state)) {
      return
    }
    if (!this.progressSearching) {
      this.progressSearching = true
      this.$store.dispatch('findObjects').then(() => {
        this.progressSearching = false
        this.$nextTick(() => {
          this.scrollToBeginningOfListResult()
        })
      })
    }
  },

  methods: {
    ...sharedMethods
  }
}
</script>
